import React, { useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { PropTypes } from 'prop-types';
import { withTheme } from 'styled-components';

import { StyledPanel } from './OverlayPanel.styled';

const OverlayPanel = ({ children, target, direction, type, onClickOutside, theme }) => {
  const panelContainer = document.createElement('div');
  const overlayRef = React.createRef();

  const position = target.getBoundingClientRect();

  const onClickDocument = (event) => {
    event.stopPropagation();
    const { current } = overlayRef;
    if (onClickOutside && current && !current.contains(event.target) && !target.contains(event.target)) {
      onClickOutside();
    }
  };
  const clickDocumentCallback = useCallback(onClickDocument, [onClickDocument]);

  useEffect(() => {
    document.body.appendChild(panelContainer);
    document.addEventListener('mousedown', clickDocumentCallback);
    document.addEventListener('touchend', clickDocumentCallback);

    return () => {
      document.body.removeChild(panelContainer);
      document.removeEventListener('mousedown', clickDocumentCallback);
      document.removeEventListener('touchend', clickDocumentCallback);
    };
  }, [panelContainer, clickDocumentCallback]);

  return createPortal(
    <StyledPanel
      theme={theme}
      position={position}
      direction={direction}
      type={type}
      onClick={onClickDocument}
      ref={overlayRef}
    >
      {children}
    </StyledPanel>,
    panelContainer
  );
};

const OverlayPanelWrapper = withTheme(OverlayPanel);
export { OverlayPanelWrapper as OverlayPanel };

OverlayPanel.defaultProps = {
  children: [],
  target: null,
  direction: 'slide-right',
  type: 'popover',
  onClickOutside: () => {}
};

OverlayPanel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  target: PropTypes.objectOf(PropTypes.any),
  direction: PropTypes.oneOf(['slide-down', 'slide-right']),
  type: PropTypes.oneOf(['tooltip', 'fullScreen', 'popover']),
  onClickOutside: PropTypes.func
};
